import { useCallback } from "react"
import { useApiExportOrders } from "../../api"
import { PrimaryButton } from "../brand/PrimaryButton"
import { useNotificationContext, Notification } from "../../notifications"

export function ExportOrdersButton() {
  const { onNotification } = useNotificationContext()
  const { mutate } = useApiExportOrders({
    onSuccess: (data) => {
      onNotification(
        new Notification(
          "Export generated",
          (
            <p>
              Please check your email for the exported CSV
            </p>
          )
        )
      )
    },
  })

  const handleClick = useCallback(
    () => mutate({}),
    [mutate]
  )

  return (
    <PrimaryButton onClick={handleClick} className="me-2">
      Export
    </PrimaryButton>
  )
}
